module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-ties-remnants.70539df1.png";